import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as salesReportActions from '../../../redux/salesReport/actions';
import submitForm from '../../../utils/submitForm';
import Spin from '../../../components/loading';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';
import ReportListFilter from './reportListFilter';
import './styles.scss';
import Table from '../../../components/table';
import { salesList } from '../../../enums/columns/salesReport';
import ExportTableToPdf from '../../../components/ExportTableToPdf/ExportTableToPdf';
import enums from '../../../enums';
import { requester } from '../../../utils';

class SalesReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorText: locales('errors.default'),
      errorFlag: false,
      currentPage: 1,
      itemsPerPage: 200,
      pageSize: 200,
      salesReport: [],
      flag: true,
      sortType: 'asc',
      sortBy: 'date',
      download: false,
      ref: React.createRef(),
    };
  }

  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }
  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=date-desc'}`;
      return query;
    }
  };

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  applyFilters = (event, btnClicked) => {
    const queryString = submitForm(event);
    this.setState(
      {
        filter: queryString,
        download: btnClicked === 'download' ? true : false,
      },
      () => this.filterAndSort(),
    );
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) {
      query = `${filter}&${sort}`;
    } else if (filter) {
      query = `${filter}`;
    } else if (sort) {
      query = `${sort}`;
    }

    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      if (this.state.download) {
        // this.props.getCafesInExcel(searchQuery);
      } else {
        this.props.getSalesReport(searchQuery);
      }
    });
  };

  sortTable = query => {
    this.setState(
      { sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' },
      () => {
        query = `${query}-${this.state.sortType}`;
        this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
      },
    );
  };

  onSortCafes = (sortField, sortType) => {
    this.setState(
      { pageNumber: 0, sort: `sort=${sortField}-${sortType}` },
      () => this.filterAndSort(),
    );
  };

  onPageChanged = currentPage => {
    this.setState({ currentPage }, () => {
      const query = this.buildSearchQuery(
        this.state.currentPage,
        this.state.itemsPerPage,
      );
      this.props.getSalesReport(query);
    });
  };

  exportExcel = async e => {
    e.preventDefault();
    const query = `sort=${this.state.sortBy}-${this.state.sortType}`;
    const response = await requester
      .getFileFromAPI({
        route: `v1/reserve/sales-report/excel?${this.state.filter}&${query}`,
        contentType: 'application/octet-stream'
      })
    const fileName = response.headers["content-disposition"]
    const file = fileName.replaceAll("attachment; filename=","")
    const { data } = response;
    var ref = this.state.ref;
    ref.current.href = URL.createObjectURL(data);
    ref.current.download = file;

    ref.current.click();
  };

  render() {
    let {
      totalRecords,
      sumCafeShare,
      sumTotalFactorAmount,
      sumToBePaidToCafePrice,
      sumBalanceAmount,
      sumCheckoutWithCafesBalances,
      rseeBalanceRemains
    } = this.props.sales;
    let { currentPage, pageSize, sortType } = this.state;

    let loading = this.props.loading;
    let error = this.props.error;
    let failed = this.props.failed;
    let message = this.props.message;

    return (
      <Spin spinning={loading}>
        <section className='page-header'>
          <h1>{locales('titles.salesReport')}</h1>
          <div className='form-actions'>
            <a style={{ display: 'none' }} href='empty' ref={this.state.ref}>
              ref
            </a>
          </div>
        </section>

        {this.state.errorFlag && this.handleAlert()}

        <section className='panel panel-default'>
          {error ? (
            <div className='alert alert-danger'>
              {locales('messages.server.error')}
            </div>
          ) : (
            <>
              {failed && <div className='alert alert-danger'>{message}</div>}

              <div className='panel-heading'>
                <i className='fas fa-list-alt px-1' />
                {locales('titles.salesReportList')}
              </div>

              <div className='panel-body'>
                <ReportListFilter applyFilters={this.applyFilters} />
                <div className='row mb-2 justify-content-start px-3'>
                  <div className='col-md-3 col-sm-6'>
                  <div className="row">
                    <label className=' text-right filter-field-label'>
                      {locales('tables.totalBox')}
                    </label>
                    <div className='mr-2'>
                      {Number(sumToBePaidToCafePrice).toLocaleString()}
                    </div>
                    </div>
                  </div>
                  <div className='col-md-3 col-sm-6'>
                  <div className="row">
                    <label className=' text-right filter-field-label'>
                      {locales('tables.totalBalanceAmount')}
                    </label>
                    <div className='mr-2'>
                      {Number(sumBalanceAmount).toLocaleString()}
                    </div>
                    </div>
                  </div>
                  <div className='col-md-3 col-sm-6'>
                  <div className="row">
                    <label className='text-right filter-field-label'>
                      {locales('tables.sumCafeShare')}
                    </label>
                    <div className='mr-2'>
                      {Number(sumCafeShare).toLocaleString()}
                    </div>
                    </div>
                  </div>
                  <div className='col-md-3 col-sm-6 '>
                  <div className="row">
                    <label className='text-right filter-field-label'>
                      {locales('tables.TotalPriceFactor')}
                    </label>
                    <div className='mr-2'>
                      {Number(sumTotalFactorAmount).toLocaleString()}
                    </div>
                    </div>
                  </div>
                  <div className='col-md-6 col-sm-6 mt-2'>
                  <div className="row">
                    <label className='text-right filter-field-label'>
                      {locales('tables.sumCheckoutWithCafesBalances')}
                    </label>
                    <div className='mr-2' style={ {direction: "ltr"}}>
                      {Number(sumCheckoutWithCafesBalances).toLocaleString()}
                    </div>
                    </div>
                  </div>
                  <div className='col-md-6 col-sm-6 mt-2'>
                    <div className="row">
                    <label className='text-right filter-field-label'>
                      {locales('tables.rseeBalanceRemains')}
                    </label>
                    <div className='mr-2'>
                      {Number(rseeBalanceRemains).toLocaleString()}
                    </div>
                    </div>
                    
                  </div>
                </div>
                <div className='d-flex justify-content-end'>
                <ExportTableToPdf
                  name='report-sell.pdf'
                  title={locales('titles.salesReport')}
                  records={this.props.salesReport}
                  columns={salesList}
                  status={enums.CAFE_RESERVATION.list}
                  extra={{
                    content: {
                      startY: 50,
                      bodyStyles: { font: 'Vazir' },
                      theme: 'plain',
                      styles: {
                        overflow: 'linebreak',
                        valign: 'middle',
                        halign: 'right',
                      },
                      body: [
                        [
                          Number(sumBalanceAmount).toLocaleString(),
                          `: ${locales('tables.totalBalanceAmount')}`,
                          Number(sumToBePaidToCafePrice).toLocaleString(),
                          `: ${locales('tables.totalBox')}`,
                        ],
                        [
                          Number(sumTotalFactorAmount).toLocaleString(),
                          `: ${locales('tables.TotalPriceFactor')}`,
                          Number(sumCafeShare).toLocaleString(),
                          `: ${locales('tables.sumCafeShare')}`,
                        ],
                        [
                          Number(rseeBalanceRemains).toLocaleString(),
                          `: ${locales('tables.rseeBalanceRemains')}`,
                          Number(sumCheckoutWithCafesBalances).toLocaleString(),
                          `: ${locales('tables.sumCheckoutWithCafesBalances')}`,
                        ],
                      ],
                    },
                  }}
                />
                  <a style={{ display: 'none' }} href="empty" ref={this.state.ref}>
                    ref
                  </a>
                  <button className='btn btn-success  m-2' onClick={this.exportExcel}>
                    <i className="fal fa-file-excel mx-1" />
                    {locales('labels.excel.output')}
                  </button>
                </div>
                <Table
                  columns={salesList}
                  dataSource={this.props.salesReport}
                  loading={loading}
                  sort={{ type: sortType, action: this.sortTable }}
                  pagination={{
                    currentPage: currentPage,
                    pageSize: pageSize,
                    totalCount: totalRecords,
                    onPageChange: this.onPageChanged,
                  }}
                />
              </div>
            </>
          )}
        </section>
      </Spin>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.salesReportReducer.getSalesReportLoading,
    fail: state.salesReportReducer.getSalesReportFailed,
    error: state.salesReportReducer.getSalesReportError,
    message: state.salesReportReducer.getSalesReportMessage,
    salesReport: state.salesReportReducer.salesReport,
    sales: state.salesReportReducer.sales,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getSalesReport: query => dispatch(salesReportActions.getSalesReport(query)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SalesReport);
